module.exports = __webpack_public_path__ + "static/media/2024Banner.8aced5b4.jpg";